import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  callIcon,
  mailIcon,
  linkedinIcon,
  instagramIcon,
  telegramIcon,
  whatsappIcon,
  facebookIcon,
  twitterIcon,
} from "../../images";
import styles from "./footer.module.css";
import { MENU_FOOTER } from "../../data";
import Button from "../button";
import Promotion from "../modals/Promotion/Promotion";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseGroups } from "../../redux/action";
import { getTokenFromCookie } from "../../utils/constants";

const Footer = () => {
  const [isPromoPopUp, setPromoPopUp] = useState(false);
  const location = useLocation();
  const showFaqLink = location.pathname.includes("courses");
  const { courseId } = location.state || {};
  const dispatch = useDispatch();
  const courseGroups = useSelector((state) => state.courseGroups);
  const user = useSelector((state) => state.user);
  const isLoggedIn = Boolean(user && getTokenFromCookie());

  useEffect(() => {
    if (courseGroups === null) {
      dispatch(fetchCourseGroups());
    }
  }, [courseGroups, dispatch]);

  const buildCourseTypePath = (group, courseType) => {
    if (courseType.type === "fast track") return "/fast-track";
    if (courseType.type === "free course")
      return `/free-course/${courseType.id}`;
    return `/courses/${group.Slug}/${courseType.type}`;
  };

  const formatLabel = (t) =>
    t
      ?.split(/[-\s]/)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  function popUpTest() {
    setPromoPopUp(true);
  }

  function onClose() {
    setPromoPopUp(false);
  }

  return (
    <section className={styles["footer"]}>
      <div className={styles["first_footer_row"]}>
        <div className={styles["first_row_info"]}>
          {/* Dynamic For Students */}
          <div className={styles["info_block"]}>
            <div className={styles["info_block_title"]}>For Students</div>
            <div className={`${styles["multi_item"]} ${styles["info_block"]}`}>
              {courseGroups?.data?.data?.length ? (
                courseGroups.data.data.map((group) => (
                  <div key={group.id} className={styles["sub_menu"]}>
                    <div className={styles["sub_sub"]}>
                      <div className={styles["sub_title"]}>
                        {group.groupName}
                      </div>
                      {(group.course_type ? [group.course_type] : []).map((ct) => {
                        const to = buildCourseTypePath(group, ct);
                        return (
                          <Link
                            key={ct.id}
                            to={to}
                            state={{ courseId: ct.id }}
                            className={styles["sub_sub_item_text"]}
                          >
                            {formatLabel(ct.type)}
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                ))
              ) : (
                <div className={styles["sub_menu"]}>
                  <div className={styles["sub_sub"]}>
                    <div className={styles["sub_sub_item_text"]}>
                      Loading...
                    </div>
                  </div>
                </div>
              )}
              {/* Optional: See all courses link */}
              <Link to="/all-course" className={styles["sub_sub_item_text"]}>
                All Courses
              </Link>
            </div>
          </div>

          {/* Other footer menu groups (exclude original hardcoded For Students) */}
          {MENU_FOOTER.filter((item) => item.name !== "For Students").map(
            (item, index) => (
              <div key={index} className={styles["info_block"]}>
                <div className={styles["info_block_title"]}>{item.name}</div>
                {item.multi ? (
                  <div
                    className={`${styles["multi_item"]} ${styles["info_block"]}`}
                  >
                    {item.subMenu.map((sub_item, idx) => (
                      <div key={idx} className={styles["sub_menu"]}>
                        <div className={styles["sub_sub"]}>
                          <div className={styles["sub_title"]}>
                            {sub_item.name}
                          </div>
                          {sub_item.menu &&
                            sub_item.menu.map((menu, j) => (
                              <Link
                                key={j}
                                to={menu.link}
                                className={styles["sub_sub_item_text"]}
                              >
                                {menu.name}
                              </Link>
                            ))}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className={`${styles["no_multi_item"]} ${styles["info_block"]}`}
                  >
                    {item.subMenu.map((sub_item, k) =>
                      sub_item.name === "FAQ" ||
                      sub_item.name === "Crash Courses" ? (
                        showFaqLink && (
                          <Link
                            key={k}
                            to={sub_item.link}
                            className={styles["sub_sub_item_text"]}
                            state={{ courseId: courseId }}
                          >
                            {sub_item.name}
                          </Link>
                        )
                      ) : (
                        <Link
                          key={k}
                          to={sub_item.link}
                          className={styles["sub_sub_item_text"]}
                        >
                          {sub_item.name}
                        </Link>
                      )
                    )}
                  </div>
                )}
              </div>
            )
          )}

          {/* UNIFIED ACCOUNT: Role Discovery CTAs */}
          <div className={styles["info_block"]}>
            <div className={styles["info_block_title"]}>Explore</div>
            <Link
              to={isLoggedIn ? "/become-a-mentor" : "/mentorsignup"}
              className={styles["sub_sub_item_text"]}
            >
              Become a Mentor
            </Link>
            <a
              href="https://www.theskillgarage.com/dashboard/recommended-courses?section=bootcamps"
              className={styles["sub_sub_item_text"]}
            >
              Upskill as a Student
            </a>
          </div>
        </div>

        <div className={styles["contacts_info"]}>
          <div className={styles["subscribe_box"]}>
            <div className={styles["description"]}>
              Get exclusive news about upcoming programs, panels and events.
            </div>

            <form>
              <div className={styles["email_input"]}>
                <label htmlFor="email">Email</label>

                <input
                  type="email"
                  id="email"
                  placeholder="Example@example.com"
                  className={styles["input"]}
                />
              </div>
            </form>

            <Button
              size="full"
              variant="secondary"
              icon="blackArrow"
              onClick={popUpTest}
            >
              Subscribe for Newsletter
            </Button>
          </div>
          <div className={styles["email_and_phone"]}>
            <a href="tel:+1-437-345-0501">
              <img src={callIcon} title="icon" alt="call-icon" />
              1-437-345-0501
            </a>

            <a href="mailto:theskillgarage@theskillgarage.com">
              <img src={mailIcon} title="icon" alt="mail-icon" />
              theskillgarage@theskillgarage.com
            </a>
          </div>
        </div>
      </div>
      <div className={styles["last_footer_row"]}>
        <div className={styles["last_row_info"]}>
          <div className={styles["info_title"]}>
            {new Date().getFullYear()} TheSkillGarage
          </div>

          <Link to="/terms-and-conditions" className={styles["info_title"]}>
            Terms of use
          </Link>
          <Link to="/refund-policy" className={styles["info_title"]}>
            Refund Policy
          </Link>
          <Link to="/privacy-policy" className={styles["info_title"]}>
            Privacy Policy
          </Link>
          <Link to="/cookie-policy" className={styles["info_title"]}>
            Cookie Policy
          </Link>
        </div>

        <div className={styles["social_block"]}>
          <a
            href="https://wa.me/message/V2IGTURYUJC2B1"
            target="_blank"
            title="WhatsApp"
            className={styles["btn social_icon"]}
            rel="noreferrer"
          >
            <img src={whatsappIcon} title="WhatsApp" alt="whatsapp-icon" />
          </a>

          <a
            href="https://x.com/theskillgarage"
            title="Twitter"
            target="_blank"
            className={styles["btn social_icon"]}
            rel="noreferrer"
          >
            <img src={twitterIcon} title="Twitter" alt="twitter-icon" />
          </a>

          <a
            href="https://www.linkedin.com/company/theskillgarage"
            target="_blank"
            title="LinkedIn"
            className={styles["btn social_icon"]}
            rel="noreferrer"
          >
            <img src={linkedinIcon} title="LinkedIn" alt="linkedin-icon" />
          </a>

          <a
            href="https://www.instagram.com/theskillgarage"
            target="_blank"
            title="Instagram"
            className={styles["btn social_icon"]}
            rel="noreferrer"
          >
            <img src={instagramIcon} title="Instagram" alt="instagram-icon" />
          </a>

          <a
            href="https://www.facebook.com/theskillgarage/"
            target="_blank"
            title="Facebook"
            className={styles["btn social_icon"]}
            rel="noreferrer"
          >
            <img src={facebookIcon} title="Facebook" alt="facebook-icon" />
          </a>

          <a
            href="link-to-telegram"
            title="Telegram"
            target="_blank"
            className={styles["btn social_icon"]}
          >
            <img src={telegramIcon} title="Telegram" alt="telegram-icon" />
          </a>
        </div>
      </div>
      {isPromoPopUp && <Promotion onClose={onClose} />}
    </section>
  );
};

export default Footer;
